import { Entity } from '@adornis/baseql/decorators.js';
import { BHOrderNr } from '@adornis/buchungsheld-db/entities/BHPayment.js';
import { getIncrementingNumber } from '@adornis/counter/api/counter.operations.js';

@Entity()
export class BHIKHOrderNr extends BHOrderNr {
  static override _class = 'BHIKHOrderNr';

  static override async create(institutionID: string) {
    const year = new Date().getFullYear();
    const nr = await getIncrementingNumber(institutionID + '::orderCounter::' + year)();
    return new BHIKHOrderNr({ year, nr });
  }

  override getOrderNr() {
    const padNr = this.nr.toString().padStart(4, '0');
    return `05/${this.year}/HDW/${padNr}`;
  }
}
